import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";

import {ch3_p06} from "../../../layouts/ch3_p06/ch3_p06"

export class Chapter3Page6 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly holly = this.addChild(new SceneSprite());
	readonly glow = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(new SceneSprite());
	readonly frameRight = this.addChild(new SceneSprite());

	dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch3_p06.call(this);

        // interactivity

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {
		super.onAnimateInComplete();

		TweenLite.delayedCall(1.5, ()=>{
			this.gotoNextState({transition: "up"});
		})
	}
}